import { render, staticRenderFns } from "./EmbeddedYoutubeVideo.vue?vue&type=template&id=23a8eeeb&scoped=true&"
import script from "./EmbeddedYoutubeVideo.vue?vue&type=script&lang=ts&"
export * from "./EmbeddedYoutubeVideo.vue?vue&type=script&lang=ts&"
import style0 from "./EmbeddedYoutubeVideo.vue?vue&type=style&index=0&id=23a8eeeb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a8eeeb",
  null
  
)

export default component.exports